<template>
  <v-dialog
    v-on="$listeners"
    v-bind="$attrs"
    :fullscreen="fullscreenModal"
    v-model="updateModal"
    scrollable
    max-width="850px"
  >
    <v-card>
      <v-toolbar flat max-height="48" height="48" color="#f8f8f8">
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn v-if="maximize" width="35" height="35" icon @click="setFullScreen()">
          <v-icon size="18">{{ fullscreenModal ? 'mdi-window-minimize' : 'mdi-window-maximize' }}</v-icon>
        </v-btn>
        <v-btn v-if="close" width="35" height="35" icon @click="updateModal = false">
          <v-icon size="18">mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text class="pa-0" style="height: 450px">
        <slot name="modal-content"></slot>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions color="#f8f8f8">
        <v-spacer></v-spacer>
        <v-btn @click="updateModal = false"> Annuler </v-btn>
        <slot name="actions"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      fullscreenModal: false,
    }
  },
  props: {
    // Etat de la modale : ouverte ou non
    value: {
      type: Boolean,
      default: () => false,
    },
    // Etat du fullscreen : ouvert en grand ou non
    fullscreen: {
      type: Boolean,
      default: () => false,
    },
    // Affiche ou non le bouton pour agrandir la modale
    maximize: {
      type: Boolean,
      default: () => false,
    },
    // Affiche ou non le bouton pour fermer la modale
    close: {
      type: Boolean,
      default: () => false,
    },
    // Le titre de la modale
    title: {
      type: String,
      default: '',
    },
  },
  methods: {
    // Permet d'agrandir ou rétrécir la modale
    setFullScreen() {
      if (this.fullscreenModal) {
        this.fullscreenModal = false
      } else {
        this.fullscreenModal = true
      }
    },
  },
  computed: {
    updateModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  mounted() {
    this.fullscreenModal = this.fullscreen
  },
}
</script>

<style></style>
